import { render, staticRenderFns } from "./SpecialistExpiredLicenses.vue?vue&type=template&id=baa73abe&"
import script from "./SpecialistExpiredLicenses.vue?vue&type=script&lang=js&"
export * from "./SpecialistExpiredLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports